import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import emailjs from 'emailjs-com';

// Initialize EmailJS with your user ID
emailjs.init("WkSf8SnShahxDs9ms");

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
